module.exports = __webpack_public_path__ + "static/img/四川省政府驻沪办杨忠副主任一行莅临集团走访慰问.c8abbf46.jpg";